import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Btn } from "@/components/erp/ui";
import { toast } from "sonner";
import { Users } from "lucide-react";

const DupGroup = ({ g, gi, isOwner, onDone }) => {
  const [primary, setPrimary] = useState(() => [...g].sort((a, b) => (b.quotation_count || 0) - (a.quotation_count || 0))[0].id);
  const [busy, setBusy] = useState(false);
  const merge = async () => {
    const others = g.filter((c) => c.id !== primary);
    const p = g.find((c) => c.id === primary);
    if (!window.confirm(`Gabungkan ${others.length} customer ke "${p.name}" (${p.code})? Customer lain akan dihapus setelah datanya dipindah.`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/customers/merge", { primary_id: primary, merge_ids: others.map((c) => c.id) });
      const mv = Object.entries(data.moved || {}).filter(([, n]) => n > 0).map(([k, n]) => `${n} ${k}`).join(", ");
      toast.success(`Digabung ke ${p.name}${mv ? ` · dipindah: ${mv}` : ""}`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal menggabungkan"); }
    setBusy(false);
  };
  return (
    <div className="border border-slate-200 rounded-xl p-3" data-testid={`dup-group-${gi}`}>
      <div className="space-y-1.5">
        {g.map((c) => (
          <label key={c.id} className={`flex items-start gap-2 p-2 rounded-lg border cursor-pointer text-xs ${primary === c.id ? "border-sky-400 bg-sky-50" : "border-slate-100 hover:bg-slate-50"}`} data-testid={`dup-cust-${c.id}`}>
            <input type="radio" name={`dup-${gi}`} checked={primary === c.id} onChange={() => setPrimary(c.id)} className="mt-0.5" data-testid={`dup-primary-${c.id}`} />
            <span className="min-w-0 flex-1">
              <span className="font-semibold text-slate-800">{c.name}</span> <span className="font-mono text-slate-400">{c.code}</span>
              {primary === c.id && <span className="ml-1 px-1.5 py-0.5 rounded bg-sky-600 text-white text-[10px]">Utama</span>}
              <span className="block text-slate-500">{[c.whatsapp || c.phone, c.email, c.company].filter(Boolean).join(" · ") || "-"}</span>
              <span className="block text-[10px] text-slate-400">{c.quotation_count || 0} quotation · {c.booking_count || 0} booking · {c.consignment_count || 0} titipan · dibuat {(c.created_at || "").slice(0, 10)}</span>
            </span>
          </label>
        ))}
      </div>
      <div className="flex justify-end mt-2">
        {isOwner ? <Btn data-testid={`dup-merge-${gi}`} onClick={merge} disabled={busy}>{busy ? "Menggabungkan…" : "Gabungkan"}</Btn>
          : <span className="text-[11px] text-slate-400">Hanya admin utama (owner) yang bisa menggabungkan.</span>}
      </div>
    </div>
  );
};

export const CustomerMergeModal = ({ open, onClose, isOwner, onMerged }) => {
  const [groups, setGroups] = useState(null);
  const load = () => { setGroups(null); api.get("/customers-duplicates").then(({ data }) => setGroups(data)).catch(() => setGroups([])); };
  useEffect(() => { if (open) load(); }, [open]);
  return (
    <Modal open={open} onClose={onClose} title="Customer Duplikat">
      <div className="space-y-3" data-testid="dup-modal">
        <p className="text-xs text-slate-500 flex items-center gap-1.5"><Users className="w-4 h-4 shrink-0" /> Grup customer dengan nomor WA / email sama. Pilih customer utama, lalu Gabungkan. Quotation, booking, titipan, project, work order, invoice & surat jalan dipindah ke customer utama; data kosong diisi dari customer lain.</p>
        {groups === null ? <p className="text-xs text-slate-400">Memuat…</p>
          : groups.length === 0 ? <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2" data-testid="dup-none">Tidak ada customer duplikat.</p>
          : groups.map((g, gi) => <DupGroup key={g.map((c) => c.id).join("-")} g={g} gi={gi} isOwner={isOwner} onDone={() => { load(); onMerged(); }} />)}
      </div>
    </Modal>
  );
};
